import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { getHandle, getLandingPageSubdomain } from 'modules/playbook/selectors'
import { setCLPSubdomain } from 'modules/playbook/actions'

import OnboardingPlaybookCLPSubdomainStep from 'layouts/OnboardingPlaybookCLPSubdomainStep'

const mapStateToProps = state => ({
  handle: getHandle(state),
  landingPageSubdomain: getLandingPageSubdomain(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setCLPSubdomain,
  }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingPlaybookCLPSubdomainStep)


// WEBPACK FOOTER //
// ./src/containers/OnboardingPlaybook/CLPSubdomainStep/index.js